import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';

import { ChatMessage } from '../chat.models';

interface EditMessageModel {
  chatId: string;
  message: ChatMessage | undefined;
}

export interface ChatElementStore {
  // Currently edited message per chat
  editMessage: Record<string, ChatMessage | undefined>;
}

const initialState: ChatElementStore = {
  editMessage: {},
};

@Injectable({
  providedIn: 'root',
})
export class ChatStore extends ComponentStore<ChatElementStore> {
  readonly editMessages$: Observable<Record<string, ChatMessage | undefined>> = this.select(
    (state) => state.editMessage,
  );

  setEditMessage = this.updater(
    (state, { chatId, message }: EditMessageModel): ChatElementStore => {
      if (!chatId) {
        return state;
      }

      return { ...state, editMessage: { ...state.editMessage, [chatId]: message } };
    },
  );

  resetEditMessage = this.updater((state, chatId: string): ChatElementStore => {
    if (!chatId) {
      return state;
    }

    const { [chatId]: _, ...editMessage } = state.editMessage;
    return { ...state, editMessage };
  });
  getEditMessage = (chatId: string | undefined): Observable<ChatMessage | undefined> =>
    this.select((state) => (chatId ? state.editMessage[chatId] : undefined));

  constructor() {
    super(initialState);
  }
}
